import * as React from 'react';
import {
  setPlanesDesdeBusqueda,
  setPlanes,
  setDataGrupoCopy,
  setEditando,
  getPlanesPorParametros
} from '../../actions/planesActions';
import { connect } from 'react-redux';
import SafeReactPaginate from '../General/SafeReactPaginate';
import BigSpinner from '../General/BigSpinner';
import GoBackArrow from '../General/GoBackArrow';
import { withNavigation } from '../General/withNavigation';
import PropTypes from 'prop-types';

const FILTER_DEBOUNCE_MS = 320;

class Busqueda extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            IdPlataforma: 0,
            Numero: null,
            IdPlan: null,
            Page: 1,
            PageSize: 10,
            CantidadTotal: 0,
            Descripcion: "",
            planes: [],
            planesToSend: [],
            isLoading: false,
            selectedNums: new Set()
        };
        this._filterDebounce = null;
    }

    componentWillUnmount() {
        if (this._filterDebounce) {
            clearTimeout(this._filterDebounce);
        }
    }


    seedSelectedFromProps = (props) => {

        let lstPlanes;

        if (Array.isArray(props.planDesdeBusqueda) && props.planDesdeBusqueda.length > 0) {

            const listaPlanes = {
                elementos: props.planDesdeBusqueda.map(p => ({
                    idPlan: p.id,
                    numeroPlan: p.numero,
                    descripcion: p.descripcion,
                    cuotas: p.cuotas
                }))
            };

            lstPlanes = listaPlanes;
        } else {
            lstPlanes = this.props.planes;
        }

        const fromElementos = (lstPlanes.elementos ?? []).map(p => p.numeroPlan).filter(n => n != null);

        const setNums = new Set(fromElementos);

        const planesToSend = (lstPlanes.elementos ?? []).map(pl => ({
            numero: pl.numeroPlan ?? pl.numero,
            descripcion: pl.descripcion,
            cuotas: pl.cuotas,
            id: pl.idPlan ?? pl.id
        }));

        this.props.setPlanesDesdeBusqueda(planesToSend);
        this.setState({ selectedNums: setNums, planesToSend });
    };

    togglePlan = (plan, checked) => {
        this.setState(prev => {
            const selectedNums = new Set(prev.selectedNums);
            const planesToSend = [...prev.planesToSend];

            if (checked) {
                selectedNums.add(plan.numero);
                if (!planesToSend.some(x => x.numero === plan.numero)) {
                    planesToSend.push({
                        numero: plan.numero,
                        descripcion: plan.descripcion,
                        cuotas: plan.cuotas,
                        id: plan.idPlan ?? plan.id
                    });
                }
            } else {
                selectedNums.delete(plan.numero);
                const i = planesToSend.findIndex(x => x.numero === plan.numero);
                if (i !== -1) planesToSend.splice(i, 1);
            }

            this.props.setPlanesDesdeBusqueda(planesToSend);
            return { selectedNums, planesToSend };
        });
    };

    componentDidMount() {
        this.props.setDataGrupoCopy(this.props.dataGrupo);

        if (this.props.idGrupo == 0) {
            this.props.setPlanesDesdeBusqueda([]);
            this.props.setPlanes([]);
        } else {
            if (this.props.idGrupo == "Nuevo") {
                this.props.setPlanes([]);
            }
            const jsonPlanDesdeBusqueda = JSON.stringify(this.props.planDesdeBusqueda);
            if (jsonPlanDesdeBusqueda !== "[]") {
                this.format_PlanesEnGrupo(this.props.planDesdeBusqueda);
            } else {
                this.format_PlanesEnGrupo(this.props.planesEnGrupo);
            }
        }

        this.seedSelectedFromProps(this.props);
        this.executeRequest();
    }

    format_PlanesEnGrupo = (listaObjeto) => {
        let newArr = [];
        if (listaObjeto != undefined) {
            for (let element of listaObjeto) {
                let newObj = {
                    numero: element.numeroPlan != null ? element.numeroPlan : element.numero,
                    descripcion: element.descripcion,
                    cuotas: element.cuotas,
                    id: element.idPlan != null ? element.idPlan : element.id
                };
                newArr.push(newObj);
            }
            this.setState({ planesToSend: newArr });
            this.props.setPlanesDesdeBusqueda(newArr);
        }
    };

    handlePageClick = (e) => {
        const selectedPage = e.selected + 1;
        this.setState({ Page: selectedPage }, () => this.executeRequest());
    };

    myChangeHandler = (e) => {
        this.setState({ [e.target.name]: e.target.value, Page: 1 }, () => {
            if (this._filterDebounce) clearTimeout(this._filterDebounce);
            this._filterDebounce = setTimeout(() => {
                this._filterDebounce = null;
                this.executeRequest();
            }, FILTER_DEBOUNCE_MS);
        });
    };


  executeRequest = async () => {
    this.setState({ isLoading: true });
    const params = {
      IdPlataforma: 1,
      Numero: this.state.Numero,
      IdPlan: this.state.IdPlan,
      Page: this.state.Numero ? 1 : this.state.Page,
      PageSize: this.state.PageSize,
      Descripcion: this.state.Descripcion
    };

    try {
      const listaPlanes = await getPlanesPorParametros(params);
      const d = listaPlanes?.data ?? {};
      const planes = d?.elementos ?? [];
      this.setState({
        planes,
        CantidadTotal: d.cantidadTotal ?? d.total ?? 0,
        Page: d.numeroPagina ?? d.page ?? 1,
        isLoading: false
      });
    } catch {
      this.setState({
        planes: [],
        CantidadTotal: 0,
        isLoading: false
      });
    }
  };

    onSubmit = async (event) => {
        event.preventDefault();
    };

    return = () => {
        this.props.setPlanesDesdeBusqueda([]);
        this.props.navigate("/Planes");
    };

    onBack = () => {
        this.props.navigate("/Planes");
    };

    agregarPlanes = () => {
        this.props.setEditando(true);
        const { idGrupoPlan } = this.props;
        const vieneDeEditar =
            idGrupoPlan !== undefined &&
            idGrupoPlan !== null &&
            idGrupoPlan !== 'Nuevo' &&
            !Number.isNaN(Number(idGrupoPlan)) &&
            Number(idGrupoPlan) > 0;

        this.props.setPlanesDesdeBusqueda(this.state.planesToSend);

        if (vieneDeEditar) {
            this.props.navigate(`/Planes/Editar/${idGrupoPlan}`);
        } else {
            this.props.navigate('/Planes/Nuevo');
        }
    };


    render() {
        const pageSize = this.state.PageSize || 10;
        const total = this.state.CantidadTotal || 0;
        const pageCount = Math.max(1, Math.ceil(total / pageSize));
        const hasPlanes = Array.isArray(this.state.planes) && this.state.planes.length > 0;

        return (
            <div className="container py-2">
                <div className="card admin-grupo-busqueda-shell border-0 bg-white">
                    <div className="admin-grupo-busqueda-header">
                        <div className="d-flex flex-wrap align-items-center gap-2">
                            <GoBackArrow onBack={this.onBack} />
                            <div>
                                <h4 className="mb-0 text-body fw-semibold">Búsqueda de planes</h4>
                                <p className="small text-body-secondary mb-0 mt-1">Marcá los planes que querés incluir en el grupo y guardá.</p>
                            </div>
                        </div>
                    </div>

                    <div className="admin-grupo-busqueda-toolbar">
                        <div className="row g-3 align-items-end">
                            <div className="col-12 col-sm-6 col-md-4">
                                <label htmlFor="numeroPlanBusqueda" className="form-label small text-body-secondary mb-1">Número de plan</label>
                                <input
                                    id="numeroPlanBusqueda"
                                    onChange={this.myChangeHandler}
                                    name="Numero"
                                    type="number"
                                    className="form-control"
                                    placeholder="Opcional"
                                />
                            </div>
                            <div className="col-12 col-sm-6 col-md-5">
                                <label htmlFor="descripcionBusqueda" className="form-label small text-body-secondary mb-1">Descripción</label>
                                <input
                                    id="descripcionBusqueda"
                                    onChange={this.myChangeHandler}
                                    className="form-control"
                                    name="Descripcion"
                                    type="text"
                                    placeholder="Buscar…"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="admin-grupo-busqueda-body">
                        {this.state.isLoading ? (
                            <BigSpinner message="Cargando planes..." />
                        ) : hasPlanes ? (
                            <form className="form-horizontal" onSubmit={this.onSubmit}>

                                <div className="admin-list-stack admin-plan-busqueda-stack">
                                    {this.state.planes.map((plan, index) => {
                                        const selected = this.state.selectedNums.has(plan.numero);
                                        const cardEstado = selected
                                            ? 'admin-list-card--vigente'
                                            : 'admin-list-card--inactivo';
                                        return (
                                        <div
                                            key={plan.idPlan ?? plan.numero ?? index}
                                            className={`admin-list-card p-3 ${cardEstado} ${selected ? 'admin-list-card--selected' : ''}`}
                                        >
                                            <div className="row g-2 align-items-center justify-content-between">
                                                <div className="col-auto">
                                                    <span className={`admin-id-badge ${selected ? 'admin-id-badge--vigente' : 'admin-id-badge--inactivo'}`}>
                                                        {plan.numero}
                                                    </span>
                                                </div>
                                                <div className="col text-break">
                                                    <div className="admin-list-card__title fw-semibold small mb-0">{plan.descripcion}</div>
                                                </div>
                                                <div className="col-auto d-flex align-items-center gap-2">
                                                    <span
                                                        className={`admin-plan-estado-pill ${selected ? 'admin-plan-estado-pill--incluido' : 'admin-plan-estado-pill--excluido'}`}
                                                        aria-hidden="true"
                                                    >
                                                        {selected ? 'Incluido' : 'No incluido'}
                                                    </span>
                                                    <div className="form-check form-switch mb-0 admin-estado-switch">
                                                        <input
                                                            name="checkBoxes"
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id={"check" + plan.numero}
                                                            checked={this.state.selectedNums.has(plan.numero)}
                                                            onChange={(e) => {
                                                                e.stopPropagation();
                                                                this.togglePlan(plan, e.target.checked);
                                                            }}
                                                            aria-label={`Seleccionar plan ${plan.numero}`}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        );
                                    })}
                                </div>

                                <div className="d-flex justify-content-center mt-3">
                                    <SafeReactPaginate
                                        previousLabel={"Anterior"}
                                        nextLabel={"Siguiente"}
                                        breakLabel={"..."}
                                        breakClassName={"break-me"}
                                        pageCount={pageCount}
                                        marginPagesDisplayed={1}
                                        pageRangeDisplayed={5}
                                        onPageChange={this.handlePageClick}
                                        containerClassName={"pagination"}
                                        subContainerClassName={"pages pagination"}
                                        activeClassName={"active"}
                                        forcePage={this.state.Page - 1}
                                    />
                                </div>

                                <div className="row align-items-center justify-content-center gap-2 mt-4 pt-3 border-top">
                                    <div className="col-auto">
                                        <button
                                            onClick={this.agregarPlanes}
                                            className="btn btn-sm background-rojo-megatone px-4"
                                            type="button"
                                        >
                                            Guardar selección
                                        </button>
                                    </div>
                                    <div className="col-auto">
                                        <button
                                            onClick={this.return}
                                            className="btn btn-sm btn-light"
                                            type="button"
                                        >
                                            Salir
                                        </button>
                                    </div>
                                </div>

                            </form>
                        ) : (
                            <div className="text-center py-4">
                                <h5 className="text-body-secondary mb-0">No se encontraron resultados</h5>
                                <p className="small text-body-secondary mt-2 mb-0">Probá otro criterio o revisá el número de plan.</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}
Busqueda.propTypes = {
    // Hooks props
    navigate: PropTypes.func,
    // Redux props
    planes: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    dataGrupo: PropTypes.object,
    idGrupo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    planDesdeBusqueda: PropTypes.array,
    planesEnGrupo: PropTypes.array,
    idGrupoPlan: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    // Actions props
    setPlanesDesdeBusqueda: PropTypes.func,
    setDataGrupoCopy: PropTypes.func,
    setPlanes: PropTypes.func,
    setEditando: PropTypes.func,
}

const mapStateToProps = (state) => ({
    dataGrupo: state.planes.dataGrupo,
    idGrupo: state.planes.idGrupo,
    planDesdeBusqueda: state.planes.planesDesdeBusqueda,
    planesEnGrupo: state.planes.planesEnGrupo,
    editando: state.planes.editando,
    idGrupoPlan: state.planes.dataGrupo.idGrupoPlan,
    planes: state.planes.grupoPorId
});

const mapDispatchToProps = {
    setPlanesDesdeBusqueda,
    setPlanes,
    setDataGrupoCopy,
    setEditando
};

export default withNavigation(connect(mapStateToProps, mapDispatchToProps)(Busqueda));
